module.exports = __webpack_public_path__ + "static/media/hs.b51b1fc2.png";